import { render, staticRenderFns } from "./fullscreen.vue?vue&type=template&id=0de4c9a2&scoped=true&"
import script from "./fullscreen.component.ts?vue&type=script&lang=ts&"
export * from "./fullscreen.component.ts?vue&type=script&lang=ts&"
import style0 from "./fullscreen.scss?vue&type=style&index=0&id=0de4c9a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de4c9a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0de4c9a2')) {
      api.createRecord('0de4c9a2', component.options)
    } else {
      api.reload('0de4c9a2', component.options)
    }
    module.hot.accept("./fullscreen.vue?vue&type=template&id=0de4c9a2&scoped=true&", function () {
      api.rerender('0de4c9a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fullscreen/fullscreen.vue"
export default component.exports